import inboxSocialIntergration from '../modules/inbox-social-integration';
import linkHandlerInitialize from '../modules/link-handler';

const initialize = () => {
    let enableLinkHandler = document.getElementsByClassName('enable-link-handler');
    if (enableLinkHandler.length) {
        linkHandlerInitialize();
    }

    const inboxSocial = new inboxSocialIntergration('btn-social-provider');
    inboxSocial.registerRedirectQueryDataHandler();
    inboxSocial.registerLoginClickHandler();
};

export default initialize;
